module.exports = __webpack_public_path__ + "fonts/2735a3a.woff2";